module.exports = __webpack_public_path__ + "img/logo.eaa5df92.png";